import React, { useState, useEffect, useMemo, useRef } from "react";
import projectService from "../services/project";
import folderService from "../services/folder";
import { swalError, swalPackageLimitReached } from "../utils/swal";
import session from "../services/session";
import userService from "../services/user";
import { getPackage } from "../utils/utils";
import Swal from "sweetalert2";
import "../css/project-page.css";
import "../css/projects.css";
import "../css/tabs.css";
import moment from "moment";
import Tour from "reactour";
import ProjectBox from "./ProjectBox";
import { useNavigate, useLocation } from "react-router-dom";
// import SearchPage from "./SearchPage/SearchPage";
import { Checkbox, Dropdown, Spin } from "antd";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ViewModuleIcon from "@material-ui/icons/ViewModule";
import ViewListIcon from "@material-ui/icons/ViewList";
import FolderIcon from "@material-ui/icons/FolderOutlined";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import FolderDropTarget from "./FolderDropTarget";
import useProjectSelection from "./projects/useProjectSelection";
import SelectionToolbar from "./projects/SelectionToolbar";
import { uploadToS3 } from "./N";

export default function Projects(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [sortField, setSortField] = useState(null);
  const [sortDir, setSortDir] = useState(null);
  const [data, setData] = useState([]);
  const [userPackage, setUserPackage] = useState({});
  const [sharedWithMe, setSharedWithMe] = useState([]);
  const [isTourOpen, setIsTourOpen] = useState(false);
  const [currentTab, setCurrentTab] = useState("project");
  const [allTags, setAllTags] = useState([]);
  const [tagsSelected, setTagsSelected] = useState([]);
  const [discoverData, setDiscoverData] = useState([]);
  const [discoverLoading, setDiscoverLoading] = useState(false);
  const [folders, setFolders] = useState([]);
  const [activeFolder, setActiveFolder] = useState(null);
  const [editingFolderId, setEditingFolderId] = useState(null);
  const [folderMenuId, setFolderMenuId] = useState(null);
  const folderThumbRef = useRef(null);
  const [thumbUploadFolderId, setThumbUploadFolderId] = useState(null);
  const [viewMode, setViewMode] = useState(
    () => localStorage.getItem("filmboard_projects_view") || "tile"
  );
  const [bulkBusy, setBulkBusy] = useState(false);

  const steps = [
    {
      selector: ".projects-selector",
      content: "This is where all projects that you created are listed.",
      style: {
        backgroundColor: "#000000",
      },
    },
    {
      selector: ".shared-projects-selector",
      content:
        "Shared projects are projects where someone invites you to their board.",
      style: {
        backgroundColor: "#000000",
      },
    },
    {
      selector: ".new-project-button-selector",
      content: "Create your new project here",
      style: {
        backgroundColor: "#000000",
      },
    },
  ];

  const isLoggedIn = useMemo(() => {
    return session.get("user");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session]);

  useEffect(() => {
    if (document.getElementById("txt-project-title"))
      document.getElementById("txt-project-title").style.display = "none";

    reload();
    loadFolders();

    // Restore tab from navigation state
    const returnTab = location.state?.tab;
    if (returnTab && returnTab !== "project") {
      setCurrentTab(returnTab);
      setTimeout(() => {
        const tabIds = { discover: "discover", shared: "profile" };
        const showId = tabIds[returnTab];
        if (showId) {
          const homeEl = document.getElementById("home");
          const showEl = document.getElementById(showId);
          if (homeEl) {
            homeEl.style.display = "none";
            homeEl.classList.remove("show", "active");
          }
          if (showEl) {
            showEl.style.display = "block";
            showEl.classList.add("show", "active");
          }
          // Update tab link active states
          document.querySelectorAll(".tabbable-line .nav-link").forEach((el) => {
            el.classList.remove("active");
          });
          const activeTabLink = document.getElementById(
            returnTab === "discover" ? "discover-tab" : "profile-tab"
          );
          if (activeTabLink) activeTabLink.classList.add("active");

          if (returnTab === "discover") loadDiscover();
        }
      }, 0);
    }
  }, []);

  useEffect(() => {
    (async () => {
      if (isLoggedIn) {
        const t = await userService.getPackage();
        if (t && t.data) {
          const pkg = getPackage(t.data.id);
          if (pkg) {
            setUserPackage(pkg);
          }
        }
      }
      // else {
      //   // if not loggin
      //   // will hide Projects tab and active Search tab
      //   const searchTabButton = document.querySelector('a[href="#search"]');
      //   searchTabButton.click();
      // }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const reload = async () => {
    if (session.get("user")) {
      setIsLoading(true);
      const keyword =
        (document.getElementById("txtSearchProjects") &&
          document.getElementById("txtSearchProjects").value) ||
        ``;
      await projectService.getAll(keyword).then((result) => {
        if (result.error) {
          Swal.close();
          swalError(result.error);
          setIsLoading(false);
          return;
        }

        if (result.data) {
          setData(result.data);
          if (result.data.length === 4) {
            //If user has not created any projects
            if (
              result.data[0].title === "Brand" &&
              result.data[1].title === "Real Estate" &&
              result.data[2].title === "Athletics" &&
              result.data[3].title === "Product"
            ) {
              if (!localStorage.getItem("filmboard_projects_tour_done")) {
                setIsTourOpen(true);
              }
            }
          }
          Swal.close();
          setIsLoading(false);
        }
      });

      await projectService.getSharedWithMe(keyword).then((result) => {
        if (result.error) {
          Swal.close();
          swalError(result.error);
          return;
        }

        if (result.data) {
          setSharedWithMe(result.data);
          Swal.close();
        }
      });
    }
  };

  const loadDiscover = async () => {
    setDiscoverLoading(true);
    const keyword =
      (document.getElementById("txtSearchDiscover") &&
        document.getElementById("txtSearchDiscover").value) ||
      ``;
    const result = await projectService.getDiscover(keyword);
    if (result.data) {
      setDiscoverData(result.data);
    }
    setDiscoverLoading(false);
  };

  const loadFolders = async () => {
    if (session.get("user")) {
      const result = await folderService.getAll();
      if (result.data) setFolders(result.data);
    }
  };

  const handleCreateFolder = async () => {
    const result = await folderService.create("Untitled Folder");
    if (result.data) {
      setFolders((prev) => [result.data, ...prev]);
      setEditingFolderId(result.data._id);
    }
  };

  const handleRenameFolder = async (id, name) => {
    setEditingFolderId(null);
    if (!name.trim()) name = "Untitled Folder";
    await folderService.rename(id, name.trim());
    setFolders((prev) =>
      prev.map((f) => (f._id === id ? { ...f, name: name.trim() } : f))
    );
  };

  const handleDeleteFolder = async (id) => {
    setFolderMenuId(null);
    await folderService.delete(id);
    setFolders((prev) => prev.filter((f) => f._id !== id));
    if (activeFolder === id) setActiveFolder(null);
    reload();
  };

  const handleFolderThumbnailUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !thumbUploadFolderId) return;
    try {
      const url = await uploadToS3([{ file }]);
      await folderService.updateThumbnail(thumbUploadFolderId, url);
      setFolders((prev) =>
        prev.map((f) =>
          f._id === thumbUploadFolderId ? { ...f, thumbnail: url } : f
        )
      );
    } catch (err) {
      swalError("Failed to upload thumbnail");
    }
    setThumbUploadFolderId(null);
    e.target.value = "";
  };

  const handleOpenFolder = (folderId) => {
    setActiveFolder(folderId);
    setFolderMenuId(null);
  };

  const getProjectsForView = () => {
    const sorted = getSortedData();
    if (activeFolder) {
      return sorted.filter((p) => p.folderId === activeFolder);
    }
    return sorted.filter((p) => !p.folderId);
  };

  const newProjectBox = () => (
    <div
      className="project-box new-project-box new-project-button-selector"
      onClick={handleCreate}
    >
      <div className="new-project-box-text">Create New Project</div>
    </div>
  );

  const renderProjects = () =>
    visibleProjects.map((project) => (
      <ProjectBox
        reload={reload}
        key={project._id}
        project={project}
        getAllTags={getAllTags}
        setData={setData}
        currentTab={currentTab}
        viewMode={viewMode}
        folders={folders}
        selectable
        selected={selection.isSelected("project", project._id)}
        selectedProjectIds={selection.selectedProjectIds}
        onToggleSelect={() => selection.toggle("project", project._id)}
        onCardClick={(e) => selection.handleItemClick(e, "project", project._id)}
        onMoveToFolder={async (projectId, folderId) => {
          await folderService.moveProject(projectId, folderId);
          reload();
          loadFolders();
        }}
      />
    ));

  const renderSharedWithMeProjects = () =>
    sharedWithMe.map((project) => (
      <ProjectBox
        reload={reload}
        key={project._id}
        project={project}
        getAllTags={getAllTags}
        setData={setSharedWithMe}
        currentTab={currentTab}
        viewMode={viewMode}
      />
    ));

  const handleCreate = async (e) => {
    e.preventDefault();
    if (userPackage.projectsLimit) {
      if (data.length >= userPackage.projects) {
        swalPackageLimitReached(
          `Package limit reached`,
          `You have reached your projects limit.`
        );
        return;
      }
    }

    const obj = {
      title: ``,
      description: ``,
      date: moment().format(),
      userId: session.get("user").id,
    };

    await projectService.add(obj).then((result) => {
      if (result.data) {
        navigate(`/n/${result.data._id}`);
      }
    });
  };

  const handleFilter = async (value, checked) => {
    const newTagsSelected = checked
      ? [...tagsSelected, value]
      : tagsSelected.filter((tag) => tag !== value);
    setTagsSelected(newTagsSelected);

    if (session.get("user")) {
      setIsLoading(true);
      const keyword =
        (document.getElementById("txtSearchProjects") &&
          document.getElementById("txtSearchProjects").value) ||
        ``;
      const projectsResult = await projectService.getAll(keyword, newTagsSelected);

      if (projectsResult.data) setData(projectsResult.data);
      if (projectsResult.error) swalError(projectsResult.error);
      setIsLoading(false);
    }
  };

  const handleViewMode = (mode) => {
    setViewMode(mode);
    localStorage.setItem("filmboard_projects_view", mode);
  };

  const handleSort = (field) => {
    if (sortField === field) {
      if (sortDir === "asc") {
        setSortDir("desc");
      } else {
        setSortField(null);
        setSortDir(null);
      }
    } else {
      setSortField(field);
      setSortDir("asc");
    }
  };

  const getSortedData = () => {
    if (!data || data.length === 0 || !sortField) return data;
    return [...data].sort((a, b) => {
      let cmp = 0;
      if (sortField === "name") {
        cmp = (a.title || "").toLowerCase().localeCompare((b.title || "").toLowerCase());
      } else if (sortField === "date") {
        cmp = new Date(a.date).getTime() - new Date(b.date).getTime();
      }
      return sortDir === "desc" ? -cmp : cmp;
    });
  };

  // Everything currently on screen, in render order — this is what Shift-range
  // selection and Cmd+A operate over.
  const visibleProjects = getProjectsForView();
  const visibleProjectIds = visibleProjects.map((p) => p._id);
  const visibleFolderIds = activeFolder ? [] : folders.map((f) => f._id);

  const selection = useProjectSelection({
    projectIds: visibleProjectIds,
    folderIds: visibleFolderIds,
  });

  // One request moves every selected project. Only folderId changes, so assets,
  // tabs, tags, collaborators and sharing all travel with the project.
  const handleBulkMove = async (folderId) => {
    const ids = selection.selectedProjectIds;
    if (!ids.length) return;
    setBulkBusy(true);
    const result = await folderService.moveProjects(ids, folderId);
    setBulkBusy(false);

    if (result.error) {
      swalError(result.error);
      return;
    }
    if (result.data && result.data.skipped > 0) {
      swalError(
        `${result.data.moved} moved. ${result.data.skipped} could not be moved because they are not yours.`
      );
    }
    selection.clear();
    await Promise.allSettled([reload(), loadFolders()]);
  };

  // Drag-and-drop lands here too, so a dropped batch takes the same path.
  const handleDropOnFolder = async (projectIds, folderId) => {
    if (!projectIds || !projectIds.length) return;
    setBulkBusy(true);
    const result = await folderService.moveProjects(projectIds, folderId);
    setBulkBusy(false);
    if (result.error) {
      swalError(result.error);
      return;
    }
    selection.clear();
    await Promise.allSettled([reload(), loadFolders()]);
  };

  const handleBulkDeleteFolders = async () => {
    const ids = selection.selectedFolderIds;
    if (!ids.length) return;

    const confirmed = await Swal.fire({
      title: `Delete ${ids.length} ${ids.length === 1 ? "folder" : "folders"}?`,
      text: "Projects inside will move back to All Projects. Nothing is deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Delete",
      confirmButtonColor: "#d03b3b",
      background: "#18181b",
      color: "#e0e0e0",
    });
    if (!confirmed.isConfirmed) return;

    setBulkBusy(true);
    const result = await folderService.bulkDelete(ids);
    setBulkBusy(false);
    if (result.error) {
      swalError(result.error);
      return;
    }
    selection.clear();
    await Promise.allSettled([reload(), loadFolders()]);
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    if (sortDir === "asc") return <ArrowUpwardIcon style={{ fontSize: "14px", marginLeft: "4px" }} />;
    return <ArrowDownwardIcon style={{ fontSize: "14px", marginLeft: "4px" }} />;
  };

  // const onClickSearchTab = () => {
  //   document.getElementById("search").style.display = "grid";
  //   document.getElementById("profile").style.display = "none";
  //   document.getElementById("home").style.display = "none";
  //   setCurrentTab("search");
  // };

  const getAllTags = async () => {
    await projectService.getAllTags().then((result) => {
      if (result.error) {
        Swal.close();
        swalError(result.error);
        return;
      }

      if (result.data) {
        setAllTags(
          result.data?.map((tag) => ({
            value: tag.id,
            label: tag.name,
          }))
        );
      } else {
        setAllTags([]);
      }
    });
  };

  const tagsFilter = (
    <div
      style={{
        background: "#191B1F",
        borderRadius: "4px",
        padding: "12px 12px 12px 20px",
        minWidth: "256px",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {allTags?.map((tag, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            gap: "12px",
            alignItems: "center",
            cursor: "pointer",
            padding: "4px 0",
          }}
          onClick={() =>
            handleFilter(tag.value, !tagsSelected.includes(tag.value))
          }
        >
          <Checkbox
            checked={tagsSelected.includes(tag.value)}
            onClick={(e) => e.stopPropagation()}
            onChange={(e) =>
              handleFilter(tag.value, e.target.checked)
            }
          />
          <span
            style={{
              color: "#C6C6C6",
              fontSize: "16px",
            }}
          >
            {tag.label}
          </span>
        </div>
      ))}
    </div>
  );

  useEffect(() => {
    getAllTags();
  }, []);

  return (
    <div className="container container-wrapper">
      <Tour
        steps={steps}
        isOpen={isTourOpen}
        onRequestClose={() => {
          setIsTourOpen(false);
          localStorage.setItem("filmboard_projects_tour_done", "true");
        }}
      />
      <div className="row mt-20 row-wrapper">
        <div className="col-12 col-sm-12 d-flex text-cente project-panel">
          <div className="tabbable-panel">
            <div className="tabbable-line">
              <ul className="nav nav-tabs" id="myTab" role="tablist">
                {/* <li className="nav-item">
                  <a
                    className="nav-link projects-selector"
                    id="home-tab"
                    data-toggle="tab"
                    href="#search"
                    role="tab"
                    style={{ paddingLeft: "0px" }}
                    aria-controls="search"
                    aria-selected="true"
                    onClick={onClickSearchTab}
                  >
                    Search
                  </a>
                </li> */}
                <li className="nav-item">
                  <a
                    className="nav-link"
                    id="discover-tab"
                    data-toggle="tab"
                    href="#discover"
                    role="tab"
                    aria-controls="discover"
                    aria-selected="false"
                    onClick={() => {
                      document.getElementById("home").style.display = "none";
                      document.getElementById("profile").style.display = "none";
                      document.getElementById("discover").style.display = "block";
                      setCurrentTab("discover");
                      loadDiscover();
                    }}
                  >
                    Discover
                  </a>
                </li>
                {isLoggedIn && (
                  <li className="nav-item">
                    <a
                      className="nav-link active projects-selector"
                      id="home-tab"
                      data-toggle="tab"
                      href="#home"
                      role="tab"
                      aria-controls="home"
                      aria-selected="true"
                      onClick={() => {
                        document.getElementById("profile").style.display = "none";
                        document.getElementById("discover").style.display = "none";
                        document.getElementById("home").style.display = "grid";
                        setCurrentTab("project");
                        reload();
                      }}
                    >
                      Projects
                    </a>
                  </li>
                )}
                {session.get("user") && (
                  <li className="nav-item shared-projects-selector">
                    <a
                      className="nav-link"
                      id="profile-tab"
                      data-toggle="tab"
                      href="#profile"
                      role="tab"
                      aria-controls="profile"
                      aria-selected="false"
                      onClick={() => {
                        document.getElementById("profile").style.display = "block";
                        document.getElementById("home").style.display = "none";
                        document.getElementById("discover").style.display = "none";
                        setCurrentTab("shared");
                      }}
                    >
                      Shared Projects
                    </a>
                  </li>
                )}
              </ul>
            </div>
          </div>
          {/*
                    <div className="col text-right">
                    {
                        session.get('user') &&
                        <button className="btn btn-styled mt-0 btn-pink share-button new-project-button-selector"
                                onClick={handleCreate}>New Project</button>
                    }
                </div>*/}
        </div>
      </div>

      <div className="row mt-20 mx-auto">
        <div className="col projectsPad">
          <div className="tab-content" id="myTabContent">
            {/* <div
              className="tab-pane fade"
              id="search"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              {currentTab === "search" && <SearchPage />}
            </div> */}

            <div
              className="tab-pane fade show active"
              id="home"
              role="tabpanel"
              aria-labelledby="home-tab"
            >
              <div className="projects-toolbar">
                <input
                  type="text"
                  className="projects-search-input"
                  onChange={(e) => reload()}
                  placeholder="Search projects..."
                  id="txtSearchProjects"
                />
                <div className="projects-sort-controls">
                  <button
                    className={`projects-sort-btn ${sortField === "name" ? "projects-sort-btn-active" : ""}`}
                    onClick={() => handleSort("name")}
                  >
                    Name {renderSortIcon("name")}
                  </button>
                  <button
                    className={`projects-sort-btn ${sortField === "date" ? "projects-sort-btn-active" : ""}`}
                    onClick={() => handleSort("date")}
                  >
                    Date {renderSortIcon("date")}
                  </button>
                  <Dropdown overlay={tagsFilter} trigger={["click"]}>
                    <button className="projects-sort-btn">Tag</button>
                  </Dropdown>
                  <div className="projects-view-toggle">
                    <button
                      className={`projects-view-btn ${viewMode === "tile" ? "projects-view-btn-active" : ""}`}
                      onClick={() => handleViewMode("tile")}
                      title="Tile view"
                    >
                      <ViewModuleIcon style={{ fontSize: "18px" }} />
                    </button>
                    <button
                      className={`projects-view-btn ${viewMode === "list" ? "projects-view-btn-active" : ""}`}
                      onClick={() => handleViewMode("list")}
                      title="List view"
                    >
                      <ViewListIcon style={{ fontSize: "18px" }} />
                    </button>
                  </div>
                </div>
              </div>

              {isLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spin />
                </div>
              ) : (
                <>
                  {viewMode === "list" && (
                    <div className="projects-list-header">
                      <span className="projects-list-header-title">Title</span>
                      <span className="projects-list-header-cell projects-list-header-tags">Tags</span>
                      <span className="projects-list-header-cell projects-list-header-assets">Assets</span>
                      <span className="projects-list-header-cell projects-list-header-date">Date</span>
                      <span className="projects-list-header-cell projects-list-header-actions"></span>
                    </div>
                  )}
                  {selection.selectionActive && (
                    <SelectionToolbar
                      projectCount={selection.selectedProjects.size}
                      folderCount={selection.selectedFolders.size}
                      folders={folders}
                      inFolder={!!activeFolder}
                      busy={bulkBusy}
                      onMoveToFolder={handleBulkMove}
                      onDeleteFolders={handleBulkDeleteFolders}
                      onClear={selection.clear}
                    />
                  )}
                  {activeFolder && (
                    <div className="folder-breadcrumb">
                      <button
                        className="folder-back-btn"
                        onClick={() => setActiveFolder(null)}
                      >
                        <ArrowBackIcon style={{ fontSize: "18px" }} />
                        All Projects
                      </button>
                      <span className="folder-breadcrumb-name">
                        {folders.find((f) => f._id === activeFolder)?.name}
                      </span>
                    </div>
                  )}
                  {!activeFolder && session.get("user") && (
                    <>
                      <input
                        type="file"
                        accept="image/*"
                        ref={folderThumbRef}
                        style={{ display: "none" }}
                        onChange={handleFolderThumbnailUpload}
                      />
                      <div className="projects-section-head">
                        <h4 className="projects-section-title">Folders</h4>
                        <span className="projects-section-meta">
                          {folders.length} {folders.length === 1 ? "folder" : "folders"}
                        </span>
                      </div>
                      <div className="folders-grid">
                        <div className="folder-box folder-box-new" onClick={handleCreateFolder}>
                          <div className="folder-box-media">
                            <span className="folder-box-plus">+</span>
                          </div>
                          <div className="folder-box-inner">
                            <span className="folder-box-name">New Folder</span>
                            <span className="folder-box-count">Create a folder</span>
                          </div>
                        </div>
                        {folders.map((folder) => (
                          <FolderDropTarget
                            key={folder._id}
                            folderId={folder._id}
                            onDrop={handleDropOnFolder}
                          >
                          <div
                            className={`folder-box ${
                              selection.isSelected("folder", folder._id)
                                ? "folder-box-selected"
                                : ""
                            }`}
                            onClick={(e) => {
                              if (
                                selection.handleItemClick(e, "folder", folder._id)
                              ) {
                                return;
                              }
                              handleOpenFolder(folder._id);
                            }}
                          >
                            <button
                              type="button"
                              className="folder-box-select"
                              aria-label={
                                selection.isSelected("folder", folder._id)
                                  ? "Deselect folder"
                                  : "Select folder"
                              }
                              aria-pressed={selection.isSelected("folder", folder._id)}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                selection.toggle("folder", folder._id);
                              }}
                            >
                              <span className="folder-box-select-box">
                                {selection.isSelected("folder", folder._id) && (
                                  <svg viewBox="0 0 16 16" width="11" height="11" aria-hidden="true">
                                    <path
                                      d="M2 8.5l4 4 8-9"
                                      fill="none"
                                      stroke="currentColor"
                                      strokeWidth="2.4"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                )}
                              </span>
                            </button>
                            <div className="folder-box-media">
                              {folder.thumbnail ? (
                                <div
                                  className="folder-box-thumbnail"
                                  style={{ backgroundImage: `url(${folder.thumbnail})` }}
                                />
                              ) : (
                                <FolderIcon className="folder-box-icon" />
                              )}
                            </div>
                            <div className="folder-box-inner">
                              <div
                                className="folder-box-menu"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setFolderMenuId(folderMenuId === folder._id ? null : folder._id);
                                }}
                              >
                                <MoreHorizIcon style={{ fontSize: "18px" }} />
                                {folderMenuId === folder._id && (
                                  <div className="folder-box-dropdown" onClick={(e) => e.stopPropagation()}>
                                    <div
                                      className="folder-box-dropdown-item"
                                      onClick={() => {
                                        setFolderMenuId(null);
                                        setThumbUploadFolderId(folder._id);
                                        setTimeout(() => folderThumbRef.current?.click(), 0);
                                      }}
                                    >
                                      Change Thumbnail
                                    </div>
                                    <div
                                      className="folder-box-dropdown-item"
                                      onClick={() => {
                                        setFolderMenuId(null);
                                        setEditingFolderId(folder._id);
                                      }}
                                    >
                                      Rename
                                    </div>
                                    <div
                                      className="folder-box-dropdown-item folder-box-dropdown-item-danger"
                                      onClick={() => handleDeleteFolder(folder._id)}
                                    >
                                      Delete
                                    </div>
                                  </div>
                                )}
                              </div>
                              {editingFolderId === folder._id ? (
                                <input
                                  className="folder-box-rename-input"
                                  autoFocus
                                  defaultValue={folder.name}
                                  onClick={(e) => e.stopPropagation()}
                                  onBlur={(e) => handleRenameFolder(folder._id, e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === "Enter") handleRenameFolder(folder._id, e.target.value);
                                    if (e.key === "Escape") setEditingFolderId(null);
                                  }}
                                />
                              ) : (
                                <span className="folder-box-name">{folder.name}</span>
                              )}
                              <span className="folder-box-count">
                                {folder.projectCount} {folder.projectCount === 1 ? "project" : "projects"}
                              </span>
                            </div>
                          </div>
                        </FolderDropTarget>
                      ))}
                      </div>
                    </>
                  )}
                  {!activeFolder && session.get("user") && (
                    <div className="projects-section-head">
                      <h4 className="projects-section-title">Projects</h4>
                      <span className="projects-section-meta">
                        {visibleProjects.length}{" "}
                        {visibleProjects.length === 1 ? "project" : "projects"}
                      </span>
                    </div>
                  )}
                  <div className={`text-center mt-20 ${viewMode === "list" ? "projects-list-view" : "test"}`}>
                    {session.get("user") && newProjectBox()}
                    {data && renderProjects()}
                  </div>
                </>
              )}
            </div>

            <div
              className="tab-pane fade"
              id="profile"
              role="tabpanel"
              aria-labelledby="profile-tab"
            >
              <div className="projects-toolbar" style={{ marginBottom: "20px" }}>
                <input
                  type="text"
                  className="projects-search-input"
                  onChange={(e) => reload()}
                  placeholder="Search projects..."
                  id="txtSearchProjects"
                />
              </div>
              {viewMode === "list" && sharedWithMe.length > 0 && (
                <div className="projects-list-header">
                  <span className="projects-list-header-title">Title</span>
                  <span className="projects-list-header-cell projects-list-header-tags">Tags</span>
                  <span className="projects-list-header-cell projects-list-header-assets">Assets</span>
                  <span className="projects-list-header-cell projects-list-header-date">Date</span>
                  <span className="projects-list-header-cell projects-list-header-actions"></span>
                </div>
              )}
              <div className={`text-center mt-20 ${viewMode === "list" ? "projects-list-view" : "test"}`}>
                {(sharedWithMe.length > 0 && renderSharedWithMeProjects()) || (
                  <div className="not-found">No projects found.</div>
                )}
              </div>
            </div>

            <div
              className="tab-pane fade"
              id="discover"
              role="tabpanel"
              aria-labelledby="discover-tab"
            >
              <div className="projects-toolbar" style={{ marginBottom: "20px" }}>
                <input
                  type="text"
                  className="projects-search-input"
                  onChange={() => loadDiscover()}
                  placeholder="Search community projects..."
                  id="txtSearchDiscover"
                />
              </div>
              {discoverLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Spin />
                </div>
              ) : (
                <div className={`text-center mt-20 ${viewMode === "list" ? "projects-list-view" : "test"}`}>
                  {discoverData.length > 0 ? (
                    discoverData.map((project) => (
                      <ProjectBox
                        reload={loadDiscover}
                        key={project._id}
                        project={project}
                        getAllTags={getAllTags}
                        setData={setDiscoverData}
                        viewMode={viewMode}
                        currentTab={currentTab}
                      />
                    ))
                  ) : (
                    <div className="not-found">No community projects found.</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
